module.exports = __webpack_public_path__ + "media/video.988125cf.mp4";